import { translate } from 'utils/translation';

export const quizSection = (index, title, elements) => ({
  index: index || 0,
  sectionType: 'QUIZ_SECTION',
  format: null,
  title: title || translate('common.quiz'),
  elements: elements || []
});